import { useState } from "react";
import { toast } from "sonner";
import { Car, Plus, Trash2 } from "lucide-react";
import { Empty, PortalHeading } from "./PortalLayout";
import { Input } from "@/components/ui/input";
import { useFetch } from "@/hooks/useFetch";
import { api, errMsg } from "@/lib/api";
import { VEHICLE_SIZES } from "@/lib/constants";

const blank = { make: "", model: "", year: "", registration: "", colour: "", size: "sedan" };

export default function Vehicles() {
  const { data, reload } = useFetch("/portal/vehicles");
  const [f, setF] = useState(blank);
  const [open, setOpen] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const add = async (e) => {
    e.preventDefault();
    try {
      await api.post("/portal/vehicles", { ...f, year: f.year ? Number(f.year) : null });
      setF(blank); setOpen(false); reload();
      toast.success("Vehicle added");
    } catch (err) { toast.error(errMsg(err)); }
  };
  const remove = async (id) => { await api.delete(`/portal/vehicles/${id}`); reload(); };

  return (
    <div data-testid="portal-vehicles">
      <PortalHeading title="My Garage" sub="Vehicles we can quote and book against."
        action={<button onClick={() => setOpen(!open)} data-testid="vehicle-add-toggle" className="flex items-center gap-2 rounded-full bg-[#020165] text-white px-5 py-2.5 text-sm font-semibold"><Plus className="h-4 w-4" />Add vehicle</button>} />
      {open && (
        <form onSubmit={add} className="mb-6 rounded-2xl bg-white p-5 grid sm:grid-cols-3 gap-3" data-testid="vehicle-add-form">
          <Input required placeholder="Make" value={f.make} onChange={set("make")} data-testid="vehicle-make-input" />
          <Input required placeholder="Model" value={f.model} onChange={set("model")} data-testid="vehicle-model-input" />
          <Input type="number" placeholder="Year" value={f.year} onChange={set("year")} data-testid="vehicle-year-input" />
          <Input placeholder="Registration" value={f.registration} onChange={set("registration")} data-testid="vehicle-reg-input" />
          <Input placeholder="Colour" value={f.colour} onChange={set("colour")} data-testid="vehicle-colour-input" />
          <select value={f.size} onChange={set("size")} className="rounded-md border bg-white px-3 text-sm" data-testid="vehicle-size-select">{VEHICLE_SIZES.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
          <button className="sm:col-span-3 rounded-full bg-[#F86900] text-[#0D141A] font-bold py-2.5" data-testid="vehicle-save-button">Save vehicle</button>
        </form>
      )}
      {data && !data.vehicles.length && <Empty testId="vehicles-empty">No vehicles yet.</Empty>}
      <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-4">
        {data?.vehicles.map((v) => (
          <div key={v.id} className="rounded-2xl bg-white p-5 flex items-start gap-4" data-testid={`vehicle-card-${v.id}`}>
            <div className="h-11 w-11 rounded-xl bg-[#020165]/10 flex items-center justify-center"><Car className="h-5 w-5 text-[#020165]" /></div>
            <div className="flex-1"><p className="font-display font-bold">{v.year} {v.make} {v.model}</p><p className="text-sm text-[#56585E]">{v.registration || "No registration"} · {v.size}</p></div>
            <button onClick={() => remove(v.id)} data-testid={`vehicle-delete-${v.id}`} className="text-[#56585E] hover:text-red-600" aria-label="Remove"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
